import BaseCard from "@components/base/Card/CardBase"
import styled from "styled-components"

export const CardContainer = styled(BaseCard)`
  position: relative;
  padding: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  min-width: 700px;
  width: 100%;
  z-index: 1;
  @media (max-width: 600px) {
    padding: ${({ theme }) => theme.spacing.sm};
    min-width: 100%;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.xs};
`

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};
`

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const TitleSpan = styled.span`
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  color: ${({ theme }) => theme.primaryText};
  @media (max-width: 600px) {
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
  }
`

export const StatusBar = styled.div<{ gradient: string }>`
  height: 4px;
  border-radius: 2px;
  background: ${({ gradient }) => gradient};
  margin-top: 4px;
`

export const StatusSelect = styled.select`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  background: none;
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  padding: ${({ theme }) => theme.spacing.xs};
  color: ${({ theme }) => theme.primaryText};
  /* max-width: 12rem; */
  cursor: pointer;

  outline: none;

  @media (max-width: 600px) {
    font-size: ${({ theme }) => theme.typography.fontSize.xs};
  }
`

export const EditButton = styled.button`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`

export const SaveButton = styled.button`
  background: ${({ theme }) => theme.success};
  border: none;
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.white};
  cursor: pointer;
`

export const CancelButton = styled.button`
  background: ${({ theme }) => theme.danger};
  border: none;
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.white};
  cursor: pointer;
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`

export const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md};
  /* margin-bottom: ${({ theme }) => theme.spacing.xs}; */
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.primaryText};
  margin: ${({ margin }) => margin};
`

export const ContactName = styled.span`
  font-weight: bold;
`

export const OccupantBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  svg {
    max-width: 1rem;
    max-height: 1rem;
  }
`

export const AnimalBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  svg {
    max-width: 1.5rem;
    max-height: 1.5rem;
  }
`

export const CreditCheckBadge = styled.div<{ ok: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ ok, theme }) => (ok ? theme.success : theme.danger)};
  font-weight: bold;
  font-size: 0.875rem;
`

export const FooterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md};
  margin-top: 1rem;
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.secondaryText};
`

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const LabelText = styled.span`
  font-weight: bold;
  color: #979797;
`

export const EditInput = styled.input`
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  padding: ${({ theme }) => theme.spacing.xs};
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  color: ${({ theme }) => theme.primaryText};
  @media (max-width: 600px) {
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
  }
`

export const ColorCircle = styled.div<{ gradient: string }>`
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 50%;
  background: ${({ gradient }) => gradient};
`

// Outer details section
export const OuterDetailsWrapper = styled.div<{ expanded: boolean }>`
  /* max-width: 500px; */
  width: 100%;
  /* When expanded, use the normal margin.
     When collapsed, use a negative margin to pull the next card up */
  margin-bottom: ${({ expanded, theme }) => (expanded ? theme.spacing.md : "-50px")};
  transition: margin-bottom 0.3s ease;
`

export const DetailsContainer = styled.div<{ expanded: boolean }>`
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    padding 0.3s ease;
  color: ${({ expanded }) => (expanded ? "black" : "transparent")};
  /* When not expanded, show a 40px peek; when expanded, show full content */
  transform: ${({ expanded }) => (expanded ? "translateY(0)" : "translateY(-50px)")};
  max-height: ${({ expanded }) => (expanded ? "500px" : "30px")};
  border-radius: ${({ theme }) => theme.components.borderRadius.medium};
  background-color: ${({ theme }) => theme.primary}20;
  width: 100%;
  padding: ${({ expanded, theme }) => (expanded ? theme.spacing.md : "0 1rem")};
  cursor: pointer;
`

export const DetailsContent = styled.div`
  opacity: 1;
  transition: opacity 0.3s ease;
`

export const Chevron = styled.span<{ expanded: boolean }>`
  display: flex;
  transition: transform 0.3s ease;
  transform: rotate(${({ expanded }) => (expanded ? "180deg" : "0deg")});
  color: ${({ theme }) => theme.primary};
  margin-top: auto;
  cursor: pointer;

  svg {
    width: 2rem;
    height: 2rem;
    margin-top: auto;
    transform: translateY(0.3rem);
    path {
      fill: ${({ theme }) => theme.primary} !important;
    }
  }
`
